import React from 'react';

import TranslatedCopy from '../../intl/translated-copy';

const UserProfileErrorDisconnection = (props) => {
  const {
    onBackButtonClick,
    onCloseModal,
  } = props;

  return (
    <div className='UserProfileErrorDisconnection'>
      <div className='UserProfileErrorDisconnection-container'>
        <div className='UserProfileErrorDisconnection-Back'>
          <button
            className='UserProfileErrorDisconnection-button'
            onClick={ onBackButtonClick }
            type='button'>
            <span className='Icon Icon--calendarArrowLeft' />
            <TranslatedCopy
              className='UserProfileErrorDisconnection-Back-text'
              copyID='PRO_HOME2.0_RETURN'
            />
          </button>
        </div>
        <div className='UserProfileErrorDisconnection-Content'>
          <div className='UserProfileErrorDisconnection-Icon'>
            <span className='Icon Icon--electricPlug' />
          </div>
          <TranslatedCopy
            className='UserProfileErrorDisconnection-Text'
            copyID='PRO_HOME_VERIFY_ERROR_TITLE_1'
            tagName='h1'
          />
          <TranslatedCopy
            className='UserProfileErrorDisconnection-Desc'
            copyID='PRO_HOME_VERIFY_ERROR_TITLE_1_DESCRIPTION'
          />
        </div>
        <button
          className='UserProfileErrorDisconnection-Button'
          onClick={ onCloseModal }>
          <TranslatedCopy
            className='UserProfileErrorDisconnection-Button-Text'
            copyID='PRO_HOME_VERIFY_ERROR_TITLE_1_BUTTON'
          />
        </button>
      </div>
    </div>
  );
};

export default UserProfileErrorDisconnection;
